// extracted by mini-css-extract-plugin
export default {"container":"CardDetails_container__JCLeM","box":"CardDetails_box__GSWrc","icon":"CardDetails_icon__hw2nq","icon_text_container":"CardDetails_icon_text_container__F0WxU"};